const routes = {
  default: "/",
  music: "/music/:musicSlug",
  episode: "/episode/:episodeSlug",
  product: "/products/:id",
  products: "/products",
  fatsuEmojis: "/product/:slug",
  landing: "/landing",
  cart: "/cart",
  checkout: "/checkout",
  complete: "/complete",
  terms: "/terms-and-conditions",
  policy: "/privacy-policy",
  cookiePolicy: "/cookie-policy",
  news: "/fatsu-in-lights",
  contact: "/contact",
  newsShow: "/:newsCategory/:id",
  history: "/history",
  account: "/profile/account",
  orderHistory: "/profile/orders",
  orderDetails: "/profile/orders/order-details",
  orderReturn: "/profile/orders/order-return",
  wishlist: "/profile/wishlist",
  bookmark: "/profile/bookmark",
  addresses: "/profile/addresses",
  logout: "/logout",
  updatePassword: "/updatepassword",
  forgotPass: "/forgotpass",
  messages: "/message",
  fatsuOrigin: "/fatsuOrigin",
  facts: "/facts-stats-faq",
  metrics: "/metrics",
  downloads: "/downloads",
  paymentmethod: "/paymentmethods",
  allEpisodes: "/allepisodes",
  shop: "/shop",
  allMusic: "/allmusic",
  purchased: "/profile/purchased",
  rentedEpisodes: "/profile/rented-episodes",
  notificationSettings: "/notifications-settings",
  payments: "/payments",
  fatsoji: "/fatsoji"
};

export default routes;
